import _ from 'lodash';

const getChild = (array, parent, tree) => {
  tree = typeof tree !== 'undefined' ? tree : [];
  parent = typeof parent !== 'undefined' ? parent : {
    id: undefined,
    objects: [],
  };

  let children = _.filter(array, (child) => {
    return child.parentId === parent.id;
  }) || [];

  if (!_.isEmpty(children)) {
    if (parent.id === undefined) {
      tree = children;
    } else {
      parent['objects'] = children || [];
    }
    if (!parent['objects']) {
      parent['objects'] = [];
    }
    _.each(children, (child) => {
      getChild(array, child);
    });
  }
  return tree;
};

const getChildList = (array, parent, tree) => {
  tree = typeof tree !== 'undefined' ? tree : [];
  parent = typeof parent !== 'undefined' ? parent : {id: undefined};

  let children = _.filter(array, (child) => {
    return child.parentId === parent.id;
  });

  if (!_.isEmpty(children)) {
    if (parent.id === undefined) {
      tree = [...tree, ...children];
    } else {
      children = children.map((child) => ({
        ...child,
        name: `${parent.name} > ${child.name}`,
      }));
      tree = [...tree, ...children];
    }
    _.each(children, (child) => {
      tree = getChildList(array, child, tree);
    });
  }
  return tree;
};

const flatten = function (obj) {
  const array = [...obj];
  return array.reduce((acc, value) => {
    acc.push(value);
    if (value.objects) {
      acc = [...acc, ...flatten(value.objects)];
    }
    return acc.map(({id, isParent, name, parentId, index, ignoreAnalytics, code}) => {
      return {
        index,
        id,
        ignoreAnalytics,
        parentId,
        name,
        code,
        isParent,
        objects: [],
      };
    });
  }, []);
};

function array_move(arr, old_index, new_index) {
  if (new_index >= arr.length) {
    let k = new_index - arr.length + 1;
    while (k--) {
      arr.push(undefined);
    }
  }
  arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
  return arr; // for testing
};



export {getChild, getChildList, flatten, array_move};



// WEBPACK FOOTER //
// ./src/utils/getChild.js